import { render, staticRenderFns } from "./TodoListEdit.vue?vue&type=template&id=551eea50&"
import script from "./TodoListEdit.vue?vue&type=script&lang=js&"
export * from "./TodoListEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports